import { useCallback, useContext, useState } from 'react';

import responseViewButtonClick from '@hh.ru/analytics-js-events/build/xhh/employer/responses/resume_card/response_view_button_click';
import { Button, Card, Text, useBreakpoint } from '@hh.ru/magritte-ui';
import { EyeOutlinedSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { ResumeCardActionsContext } from 'src/components/ResumeCard/Actions/Context';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

const TrlKeys = {
    buttonText: 'employer.vacancyResponses.markAsRead',
    ariaLabel: 'resume.card.action.markAsRead.ariaLabel',
};

interface Props {
    isMobile?: boolean;
    markAsRead: () => void;
    topicId?: string;
    messagesCount?: number;
    closeAdditionalMenu?: () => void;
}

const MarkCardAsRead: TranslatedComponent<Props> = ({
    isMobile,
    markAsRead,
    topicId,
    messagesCount,
    closeAdditionalMenu,
    trls,
}) => {
    const inEmployerSubstatesExp = useSelector((state) => state.isEmployerSubstatesExp);
    const isHiringManagerExp = useSelector((state) => state.isHiringManagerExperiment);
    const { isM, isGtM } = useBreakpoint();

    const { vacancyId, isChangeState } = useContext(ResumeCardActionsContext);

    const [isLoading, setIsLoading] = useState(false);

    const handleClick = useCallback(() => {
        if (topicId) {
            responseViewButtonClick({ topicId, vacancyId });
        }
        setIsLoading(true);
        markAsRead();
        closeAdditionalMenu?.();
    }, [closeAdditionalMenu, markAsRead, topicId, vacancyId]);

    if (closeAdditionalMenu) {
        return (
            <Card
                onClick={handleClick}
                borderRadius={16}
                padding={12}
                paddingLeft={16}
                hoverStyle="secondary"
                stretched
                data-qa="employee-mark-topic-read"
            >
                <Text style="primary" typography="label-2-regular">
                    {trls[TrlKeys.buttonText]}
                </Text>
            </Card>
        );
    }

    if (inEmployerSubstatesExp && isM && isChangeState) {
        return null;
    }

    return (
        <Button
            stretched={isMobile}
            size="small"
            mode="secondary"
            icon={<EyeOutlinedSize16 />}
            loading={isLoading}
            onClick={handleClick}
            aria-label={trls[TrlKeys.ariaLabel]}
            data-qa="employee-mark-topic-read"
        >
            {isGtM && !isHiringManagerExp && (!messagesCount || messagesCount < 10) && trls[TrlKeys.buttonText]}
        </Button>
    );
};

export default translation(MarkCardAsRead);
